module.exports = __webpack_public_path__ + "assets/img/returnpage.61bf0148.png";